/*
 *==================================================
 * Licensed Materials - Property of HCL Technologies
 *
 * HCL Commerce
 *
 * (C) Copyright HCL Technologies Limited 2021
 *
 *==================================================
 */
//Standard libraries
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Link, useLocation } from "react-router-dom";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
//custom libraries
import { useShopOnBehalf } from "../hooks";
import { BackButton, Button, ConfirmationDialog } from "../components";
import { DASHBOARD } from "../constants/routes";
import { TableDialogOption } from "../constants/table";

interface CustomerDetailFormProps {
  changeCustomerStatus: Function;
  clickResetPassword: Function;
  cusinfo: any;
  [extraProps: string]: any;
}
const CustomerDetailForm: React.FC<CustomerDetailFormProps> = ({
  changeCustomerStatus,
  clickResetPassword,
  cusinfo,
  showEditForm,
}) => {
  const isV9 = process.env.COMMERCE_VERSION === "9";
  const { t } = useTranslation();
  const location: any = useLocation();
  const { shopOnBehalf } = useShopOnBehalf();
  const [dialogOption, setDialogOption] = useState<TableDialogOption | any>({});

  return (
    <Grid container direction="column" spacing={2}>
      <Grid item>
        <Link className="icon-text" to={location.state?.from || DASHBOARD}>
          <BackButton label={t("Common.BackToLanding")} />
        </Link>
      </Grid>
      <Grid item>
        <Typography variant="h2">{cusinfo.customerDetails?.logonId}</Typography>
      </Grid>
      <Grid item>
        <Button
          fullWidth
          disabled={
            isV9
              ? cusinfo.status === 0
              : cusinfo.userRegistry?.status === "0" || showEditForm
          }
          onClick={() => shopOnBehalf(cusinfo)}>
          {t("Table.Actions.ShopForThisUser")}
        </Button>
      </Grid>
      <Grid item>
        <Typography variant="h3" component="span">
          {t("Customer.AccountStatus")}
        </Typography>
        <Typography variant="body1" component="span">
          {t(
            `Customer.Status${
              isV9 ? cusinfo.status : cusinfo.userRegistry?.status
            }`
          )}
        </Typography>
      </Grid>
      <Grid item>
        <Button
          variant="outlined"
          fullWidth
          color="primary"
          disabled={showEditForm}
          onClick={() => {
            const dOption: TableDialogOption = {
              message: {
                key:
                  "Customer.DisableEnableDialogHeading" +
                  (isV9 ? cusinfo.status : cusinfo.userRegistry?.status),
                params: {
                  user: cusinfo.logonId,
                },
              },
              onConfirm: () => {
                changeCustomerStatus(cusinfo);
                setDialogOption({});
              },
              onCancel: () => setDialogOption({}),
              confirmLabel:
                "Table.Actions.ToggleAccountLock" +
                (isV9 ? cusinfo.status : cusinfo.userRegistry?.status),
              cancelLabel: "Table.Actions.Cancel",
            };
            setDialogOption(dOption);
          }}>
          {t(
            `Table.Actions.ToggleAccountLock${
              isV9 ? cusinfo.status : cusinfo.userRegistry?.status
            }`
          )}
        </Button>
      </Grid>
      <Grid item>
        <Button
          variant="outlined"
          fullWidth
          color="primary"
          disabled={
            isV9
              ? cusinfo.status === 0
              : cusinfo.userRegistry?.status === "0" || showEditForm
          }
          onClick={() => {
            const dOption: TableDialogOption = {
              message: {
                key: "Customer.ResetPasswordDialogHeading",
                params: {
                  user: cusinfo.logonId,
                },
              },
              onConfirm: () => {
                clickResetPassword(cusinfo);
                setDialogOption({});
              },
              onCancel: () => setDialogOption({}),
              confirmLabel: "Table.Actions.ResetPassword",
              cancelLabel: "Table.Actions.Cancel",
            };
            setDialogOption(dOption);
          }}>
          {t(`Table.Actions.ResetPassword`)}
        </Button>
      </Grid>
      <ConfirmationDialog
        heading={dialogOption.message}
        confirmLabel={dialogOption.confirmLabel}
        cancelLabel={"Table.Actions.Cancel"}
        onConfirm={dialogOption.onConfirm}
        onCancel={dialogOption.onCancel}
      />
    </Grid>
  );
};
export default CustomerDetailForm;
